import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Language, SUPPORTED_LANGUAGES, getBrowserLanguage } from "../../i18n/translations";

interface LanguageState {
  current: Language;
  supported: Language[];
}

const initialState: LanguageState = {
  current: (localStorage.getItem("selectedLanguage") as Language) || getBrowserLanguage(),
  supported: SUPPORTED_LANGUAGES,
};

const languageSlice = createSlice({
  name: "language",
  initialState,
  reducers: {
    setLanguage: (state, action: PayloadAction<Language>) => {
      if (state.supported.includes(action.payload)) {
        state.current = action.payload;
        localStorage.setItem("selectedLanguage", action.payload);
        // Set HTML lang attribute for accessibility
        document.documentElement.lang = action.payload;
        // Set text direction for RTL languages
        if (action.payload === "ar") {
          document.documentElement.dir = "rtl";
        } else {
          document.documentElement.dir = "ltr";
        }
      }
    },
    initializeLanguage: (state) => {
      const savedLanguage = localStorage.getItem("selectedLanguage") as Language | null;
      const languageToUse = savedLanguage || getBrowserLanguage();
      
      if (state.supported.includes(languageToUse)) {
        state.current = languageToUse;
        document.documentElement.lang = languageToUse;
        if (languageToUse === "ar") {
          document.documentElement.dir = "rtl";
        } else {
          document.documentElement.dir = "ltr";
        }
      }
    },
  },
});

export const { setLanguage, initializeLanguage } = languageSlice.actions;
export default languageSlice.reducer;
